/**
 * Brand icons for Google Meet and Zoom rendered as inline SVG.
 * Use them anywhere the app needs to communicate which video-call
 * platform a student/teacher is about to enter.
 */

export function MeetIcon({ className = "h-3.5 w-3.5" }) {
  return (
    <svg viewBox="0 0 87.5 72" className={className} aria-label="Google Meet" role="img">
      <path fill="#00832d" d="M49.5 36l8.53 9.75 11.47 7.33 2-17.02-2-16.64-11.69 6.44z" />
      <path fill="#0066da" d="M0 51.5V66c0 3.32 2.69 6 6 6h14.5l3-10.96-3-9.54L10.55 48.5z" />
      <path fill="#e94235" d="M20.5 0L0 20.5l10.55 9.04 9.95-1.04 3-9.54-3-10.04z" />
      <path fill="#2684fc" d="M0 51.5h20.5V20.5H0z" />
      <path fill="#00ac47" d="M82.6 8.68L69.5 19.42v33.66l13.16 10.79c1.97 1.54 4.85.14 4.85-2.37V11c0-2.54-2.92-3.93-4.91-2.32zM49.5 36v15.5H20.5V72H63.5c3.32 0 6-2.68 6-6V53.08z" />
      <path fill="#ffba00" d="M63.5 0h-43v20.5h29V36l20-.04V6c0-3.32-2.68-6-6-6z" />
    </svg>
  );
}

export function ZoomIcon({ className = "h-3.5 w-3.5" }) {
  return (
    <svg viewBox="0 0 256 256" className={className} aria-label="Zoom" role="img">
      <rect width="256" height="256" rx="40" fill="#2D8CFF" />
      <path
        fill="#fff"
        d="M192.9 100.2v55.5c0 5.4-2.9 8.2-8.2 8.2H89.7c-19.1 0-34.6-15.5-34.6-34.6v-55.5c0-5.4 2.9-8.2 8.2-8.2h95.1c19.1 0 34.5 15.5 34.5 34.6zm14.9 6.4l29.4-21.3c2.7-2 5.9-1.4 5.9 3v79.3c0 5.1-2.8 5.5-5.9 3l-29.4-21.3z"
      />
    </svg>
  );
}
